import React from 'react';
import { Link } from 'react-router-dom';

export default function SignupPage() {
  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: wire up real account creation
  };

  return (
    <div className="auth-page">
      <div className="auth-card hud-frame">
        <h1>Sign Up</h1>
        <p className="sub">{'// CREATE_NEW_ACCOUNT'}</p>

        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label>Full Name</label>
            <input type="text" placeholder="Your name" required />
          </div>
          <div className="auth-field">
            <label>Email</label>
            <input type="email" placeholder="you@example.com" required />
          </div>
          <div className="auth-field">
            <label>Password</label>
            <input type="password" placeholder="••••••••" required />
          </div>
          <button type="submit" className="auth-submit">[ CREATE_ACCOUNT ]</button>
        </form>

        <p className="auth-switch">
          Already have an account? <Link to="/login">Login</Link>
        </p>
      </div>
    </div>
  );
}